import { render } from "./AuthEvents.vue?vue&type=template&id=1c784297"
import script from "./AuthEvents.vue?vue&type=script&lang=js"
export * from "./AuthEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__